import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtGuestInfoSection({}) {
  const isMobile = useMobile();

  const renderBox = (icon, title, subtitle, containerStyle) => {
    return (
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            alignItems: "center",
            padding: 30,
          },
          containerStyle,
        ]}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtMaterialIcon name={icon} size={34} color="#006AFF" />
        </View>
        <NtText
          style={{
            color: "white",
            fontSize: 14,
            fontWeight: "600",
            marginTop: 15,
            textAlign: "center",
          }}
        >
          {title}
        </NtText>

        <NtText
          style={{
            color: "#8493a8",
            fontSize: 12,
            fontWeight: "500",
            marginTop: 15,
            textAlign: "center",
          }}
        >
          {subtitle}
        </NtText>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 600 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/8b829285038deadeb5bb2192b60b5a325772ace1.jpg")}
    >
      <View
        style={{
          width: "100%",
          flexDirection: isMobile ? "column" : "row",
          marginTop: 20,
        }}
      >
        {renderBox(
          "bell-ring",
          "Guest-Coast",
          "Receive emergency broadcast and notifications from the ship.",
          { marginRight: isMobile ? 0 : 10, flex: 1 }
        )}
        {renderBox(
          "notebook",
          "Guest-Guide",
          "Passengers can type questions that are answered by an on-ship A.I. chat bot.",
          {
            marginRight: isMobile ? 0 : 10,
            marginTop: isMobile ? 10 : 0,
            flex: 1,
          }
        )}
        {renderBox(
          "magnify",
          "Guest-Friend",
          "Locate other guest or keep track of kids. Cruise Lines can target market passengers by location.",
          { flex: 1, marginTop: isMobile ? 10 : 0 }
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 280,
  },
});

export default NtGuestInfoSection;
